package ai.wagemix.web.theme

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.theme.colors.palette.MutablePalette
import com.varabyte.kobweb.silk.theme.colors.palette.Palette

/**
 * Site-only colours that have no foundation role: the Penpot `wagemix.color.*` tokens the
 * redesign kept. Read them through `colorMode.toPalette().wagemix` in a `CssStyle`, or
 * through [WMWebTheme.colors] in a composable.
 */
interface WMWebColors {
    /** The chart card fill; equals the fscharts canvas colour in the same mode. */
    val chartCanvas: Color
    /** The fscharts `Role(primary)` series colour, for legends the page draws itself. */
    val chartSeries: Color
    /** The fscharts `Role(secondary)` colour used for projected regions. */
    val chartProjection: Color
    /** The soft brand glow behind the landing hero. */
    val heroGlow: Color
    /** The colour of card and dialog shadows (carries its own alpha). */
    val shadow: Color
    val tierBronze: Color
    val tierSilver: Color
    val tierGold: Color
    val tierPlatinum: Color
    val tierDiamond: Color
}

class WMMutableWebColors(palette: MutablePalette): MutablePalette.ColorGroup(palette, "wagemix"), WMWebColors {
    override var chartCanvas by paletteEntry()
    override var chartSeries by paletteEntry()
    override var chartProjection by paletteEntry()
    override var heroGlow by paletteEntry()
    override var shadow by paletteEntry()
    override var tierBronze by paletteEntry()
    override var tierSilver by paletteEntry()
    override var tierGold by paletteEntry()
    override var tierPlatinum by paletteEntry()
    override var tierDiamond by paletteEntry()
}

val Palette.wagemix: WMWebColors
    get() = (this as MutablePalette).wagemix

val MutablePalette.wagemix: WMMutableWebColors
    get() = WMMutableWebColors(this)
